/* Refurb Phone collection filter bar: dropdowns, show more, AJAX filtering */
(function () {
  var root = document.querySelector('[data-rp-section]');
  if (!root) return;
  var sectionId = root.getAttribute('data-rp-section');
  var moreOpen = false;

  function rowCount() {
    var w = window.innerWidth;
    return w < 768 ? 4 : w < 901 ? 3 : w < 1101 ? 4 : 5;
  }

  function setupMore() {
    var grid = root.querySelector('[data-rp-grid]');
    var btn = root.querySelector('[data-rp-more]');
    if (!grid || !btn) return;
    var items = grid.querySelectorAll('[data-rp-dd]');
    var n = rowCount();
    var hasActiveExtra = false;
    items.forEach(function (el, i) {
      if (i >= n) {
        el.setAttribute('data-extra', '');
        if (el.classList.contains('rp-dd--active')) hasActiveExtra = true;
      } else el.removeAttribute('data-extra');
    });
    if (hasActiveExtra) moreOpen = true;
    if (items.length <= n) { btn.hidden = true; grid.classList.remove('rp-collapsed'); return; }
    btn.hidden = false;
    grid.classList.toggle('rp-collapsed', !moreOpen);
    btn.setAttribute('aria-expanded', moreOpen ? 'true' : 'false');
    btn.querySelector('[data-more-text]').hidden = moreOpen;
    btn.querySelector('[data-less-text]').hidden = !moreOpen;
  }

  function closeAll(except) {
    root.querySelectorAll('details[data-rp-dd][open]').forEach(function (d) { if (d !== except) d.removeAttribute('open'); });
  }

  var ctrl = null, timer = null;

  /* When a colour filter is active the theme marks the matching variant image
     as active, but that image is a "manual" lazy background the theme only
     loads with its own collection script. Load those here. */
  function loadManual(el) {
    if (el.getAttribute('data-rp-done')) return;
    var src = el.getAttribute('data-lazy-bgset-src');
    if (!src) return;
    src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=600';
    el.style.backgroundImage = 'url("' + src + '")';
    el.style.backgroundSize = el.getAttribute('data-parent-fit') || 'contain';
    el.style.backgroundPosition = 'center';
    el.style.backgroundRepeat = 'no-repeat';
    el.style.opacity = '1';
    el.classList.add('lazyloaded');
    el.setAttribute('data-rp-done', '1');
  }

  function fixBlocks(scope) {
    scope.querySelectorAll('.product-block').forEach(function (b) {
      var active = b.querySelector('.product-block__image--active');
      if (!active) {
        active = b.querySelector('.product-block__image--primary') || b.querySelector('.product-block__image');
        if (active) active.classList.add('product-block__image--active');
      }
      b.querySelectorAll('.product-block__image--active .lazyload--manual, .product-block__image--show-on-hover .lazyload--manual').forEach(loadManual);
    });
  }

  /* Images in swapped HTML must be loaded explicitly: the theme's lazy loader
     only watches what was on the page at start. */
  function showImages(scope) {
    var ls = window.lazySizes;
    /* The theme hides every product image until one is marked active; when a
       colour filter is applied the server sometimes marks none. */
    fixBlocks(scope);
    scope.querySelectorAll('img[data-srcset], img[data-src], [data-bgset]').forEach(function (el) {
      if (el.classList.contains('lazyloaded')) return;
      if (ls && ls.loader && ls.loader.unveil) {
        try { ls.loader.unveil(el); return; } catch (e) {}
      }
      if (el.tagName === 'IMG') {
        if (el.dataset.srcset) {
          el.setAttribute('srcset', el.dataset.srcset);
          el.setAttribute('sizes', (el.getBoundingClientRect().width || 300) + 'px');
        }
        if (el.dataset.src) el.setAttribute('src', el.dataset.src);
      }
      el.classList.remove('lazyload');
      el.classList.add('lazyloaded');
    });
  }

  function load(url, push) {
    var u = new URL(url, location.origin);
    u.searchParams.delete('page');
    var fetchUrl = new URL(u.toString());
    fetchUrl.searchParams.set('section_id', sectionId);
    if (ctrl) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    root.classList.add('rp-loading');
    fetch(fetchUrl.toString(), { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['#rp-filters', '#rp-results', '#rp-pagination'].forEach(function (sel) {
          var fresh = doc.querySelector(sel), old = root.querySelector(sel);
          if (fresh && old) old.replaceWith(fresh);
        });
        if (push) history.pushState({ rp: 1 }, '', u.pathname + u.search);
        setupMore();
        var res = root.querySelector('#rp-results');
        if (res) {
          showImages(res);
          setTimeout(function () { showImages(res); }, 400);
        }
        document.dispatchEvent(new CustomEvent('rp:filters:updated'));
        root.classList.remove('rp-loading');
        var top = root.querySelector('#rp-filters');
        if (top && top.getBoundingClientRect().top < 0) top.scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        location.href = u.toString();
      });
  }

  function loadSoon(url) {
    clearTimeout(timer);
    timer = setTimeout(function () { load(url, true); }, 250);
  }

  function formUrl(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (String(v).trim() !== '') params.append(k, v); });
    var qs = params.toString();
    return form.getAttribute('action') + (qs ? '?' + qs : '');
  }

  root.addEventListener('change', function (e) {
    var form = e.target.closest('#rp-filter-form');
    if (!form || e.target.type === 'number') return;
    loadSoon(formUrl(form));
  });

  root.addEventListener('submit', function (e) {
    var form = e.target.closest('#rp-filter-form');
    if (!form) return;
    e.preventDefault();
    load(formUrl(form), true);
  });

  root.addEventListener('click', function (e) {
    var link = e.target.closest('[data-rp-link]');
    if (link && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      e.preventDefault();
      closeAll();
      load(link.href, true);
      return;
    }
    var more = e.target.closest('[data-rp-more]');
    if (more) {
      moreOpen = !moreOpen;
      setupMore();
      return;
    }
    var summary = e.target.closest('details[data-rp-dd] > summary');
    if (summary) closeAll(summary.parentNode);
  });

  document.addEventListener('click', function (e) { if (!e.target.closest('details[data-rp-dd]')) closeAll(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  window.addEventListener('popstate', function () { load(location.href, false); });
  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(setupMore, 150); });
  setupMore();
  var initial = root.querySelector('#rp-results');
  if (initial) fixBlocks(initial);
})();
